<template>
  <span class="is-date">{{ prettyFormat() }}</span>
</template>

<script lang="ts">
/**
 * Display date nicely
 */
import { Component, Vue } from 'vue-property-decorator';
import { isSameDay } from 'date-fns';
import { formatAnyDate } from '@/utils/helpers/dates';

@Component({
  props: {
    when: Date,
    alwaysLong: Boolean,
  },
})
export default class PrettyDate extends Vue {
  private readonly when!: Date;
  private readonly alwaysLong!: boolean;

  protected prettyFormat(): string {
    if (isSameDay(this.when, new Date()) && !this.alwaysLong) {
      return `${this.$t('today')}`;
    } else {
      return formatAnyDate(this.when, `'MMM dd'`);
    }
  }
}
</script>
<style lang="scss" scoped>
.is-date {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
